export enum MenuLevel {
  Root = 0,
  Level1 = 1,
  Level2 = 2,
  Level3 = 3
}
